<template>
  <div>
    <div class="flex flex-between">
      <div>
        <slot name="title"/>
      </div>
      <div class="flex flex-right">
        <sTooltip
          v-if="tender && !tender.createdByExternalApi"
          :content="$t('Tenders.HintDeleteButton')"
          :disabled="!!selected.length"
          placement="top"
          trigger="hover">
          <sButton
            class="my-auto"
            :disabled="!selected.length"
            icon="delete"
            type="text"
            @click="deleteLots">
            {{ $t('Purchasing.Remove') }}
          </sButton>
        </sTooltip>
        <div
          v-if="useImportXLS"
          class="my-auto">
          <ImportXLS
            v-if="tender"
            :disabled="imported"
            only_one
            :tender="tender"
            @finishImportLots="imported = false"
            @onSubmit="$event => updateCart($event)"
            @onSubmitTender="$event => updateCart($event, true)"
            @startImportLots="imported = true"/>
          <InDevelopmentInfo
            v-else-if="$can('add', 'appResources')"
            condition
            prevent>
            <template #activator>
              <ImportXLS
                btn_class="mx-0"/>
            </template>
          </InDevelopmentInfo>
        </div>
      </div>
    </div>
    
    <RowsTable
      :additional_fields.sync="additionalFieldsLots"
      :change-field="checkValid"
      class="mt-6"
      :disabled="imported"
      :headers="headers"
      new-design
      :positions.sync="positions"
      :selected="selected"
      show-select
      :tender.sync="tenderMutable"
      validate-prop-prefix="lots"
      @cancelSelection="deleteLot"
      @copyItem="copyItem"
      @no-data-click="addedLot"
      @update:selected="setSelected"
      @updateAdditionalColumns="updateAdditionalColumns"/>
    <div
      v-if="!tender.createdByExternalApi"
      class="mt-4 text-left">
      <sButton
        data-qa="btn-added-lot"
        :disabled="imported || (tender.biddingType.onlyOneLotPerTender && positions.length)"
        icon="plus"
        type="text"
        @click="addedLot">
        {{ $t('Tenders.ToAddLot') }}
      </sButton>
    </div>
  </div>
</template>

<script>
import RowsTable from 'components/common/blocks/RowsTable.vue'
import ImportXLS from 'components/tenders/dialogs/ImportXLS/ImportXLS.vue'
import InDevelopmentInfo from 'components/common/elements/InDevelopmentInfo.vue'

import tenderLotsBaseMixin from 'mixins/tenderLotsBaseMixin.js'

export default {
  name: 'EditLot',
  mixins: [tenderLotsBaseMixin],
  data() {
    return {
      selected: [],
    }
  },
  methods: {
    setSelected(ids) {
      this.selected = ids
    },
    copyItem(value) {
      const oldLot = this.$_.cloneDeep(value)
      let newLot = this.createLotTemplate()
      
      newLot.nomenclatureId = oldLot.nomenclatureId
      newLot.measuringUnit = oldLot.measuringUnit
      newLot.lotSubject = oldLot.lotSubject
      newLot.description = oldLot.description
      
      this.mixin_setAdditionalFieldsToLot(newLot)
      this.positions = [...this.positions, newLot]
    },
    deleteLots() {
      if (!this.selected?.length) {
        return
      }
      this.positions = this.$_.cloneDeep(this.positions).filter(i => !this.selected.includes(i.lotNumber)).map((item, index) => {
        item.lotNumber = index + 1
        return item
      })
      this.selected = []

      this.updateRulesAfterChangeLots()
    },
    deleteLot(value) {
      const result = this.$_.cloneDeep(this.positions)
      const index = result.findIndex(obj => obj.lotId === value.lotId && obj.lotNumber === value.lotNumber)
      if (index !== -1) {
        result.splice(index, 1)
      }
      let numRow = 1
      const newSelect = []

      result.forEach((item) => {
        const selectedIndex = this.selected.findIndex(selectItem => selectItem === item.lotNumber)
        if (selectedIndex !== -1) {
          newSelect.push(numRow)
        }
        item.lotNumber = numRow
        numRow += 1
      })
      this.positions = result
      this.selected = newSelect

      this.updateRulesAfterChangeLots()
    },
    async addedLot() {
      let newLot = this.createLotTemplate()
      this.mixin_setAdditionalFieldsToLot(newLot)
      this.positions = [...this.positions, newLot]
    },
  },
  components: {
    ImportXLS,
    RowsTable,
    InDevelopmentInfo,
  },
}
</script>